import { Box, BoxProps, createComponent, Flex, space, Text } from '@workday/canvas-kit-react'
import React from 'react'

export interface EmptyStateProps extends BoxProps {
  children?: React.ReactNode
}

const EmptyStateHeading = (props: any) => {
  return (
    <Text typeLevel="heading.medium" textAlign="center">
      {props.children}
    </Text>
  )
}

const EmptyStateBody = (props: any) => {
  return (
    <Text typeLevel="body.medium" textAlign="center">
      {props.children}
    </Text>
  )
}

export const EmptyState = createComponent('div')({
  displayName: 'EmptyState',
  Component: ({ children, ...elemProps }: EmptyStateProps, ref, Element) => {
    return (
      <Box ref={ref} as={Element} padding="l" {...elemProps}>
        <Flex flexDirection="column" gap={space.m} alignItems="center">
          {children}
        </Flex>
      </Box>
    )
  },
  subComponents: {
    Heading: EmptyStateHeading,
    Body: EmptyStateBody
  }
})
